
import $ from 'jquery';

const JS_PREFIX = 'js-campaign-editor-slots';
const CSS_PREFIX = 'campaign-editor-slots';
const SLOT_FIND_TIMEOUT = 5000;

class CampaignEditorSlots {
  dom = {
    $el: null,
    $items: null
  }
  timeout = null;

  constructor(el) {
    this.dom.$el = $(el);
  }

  applyIconChanges($icons) {

    this.dom.$items.each(function () {
      const $item = $(this);
      const slotId = $item.data('slot-id');
      const slotTitle = $item.data('slot-title');

      // Replace original slot text and add custom class
      const $cmSlot = $icons.find(`.cm-slot-icon[data-slot-id="${slotId}"]`);
      $cmSlot.text(slotTitle);
      $cmSlot.addClass(`${CSS_PREFIX}__icon`);
    });
  }

  // Try to locate editor icons, so we can replace their content with our own
  findEditorIcons() {
    if(!this._startFind) {
      this._startFind = Date.now();
    }

    setTimeout(() => {
      const $icons = $('body > .cm-icons');
      if(!$icons.length) {
        // Check again if we have time left
        if(this._startFind + SLOT_FIND_TIMEOUT > Date.now()) {
          this.findEditorIcons();
        }
      } else {
        this._startFind = null;
        this.applyIconChanges($icons);
      }
    }, 300)
  }

  init() {
    if(!this.dom.$el.length) {
      return;
    }

    this.dom.$items = this.dom.$el.find(`.${JS_PREFIX}__item`);

    this.findEditorIcons();
  }
}


export default {
  init: () => {
    $(`.${JS_PREFIX}`).each(function () {
      const editorSlots = new CampaignEditorSlots(this);
      editorSlots.init();
    });
  }
}
